import Service from '@/service'
import { BUILDING_STATUS } from '@/constant'
export default {
    data () {
        return {
            page: 1,
            selected_tab: '热门楼盘',
            tabs: [
                {
                    key: '热门楼盘',
                    name: '热门楼盘'
                },
                {
                    key: '即将预售',
                    name: '即将预售'
                },
                {
                    key: '最新取证',
                    name: '最新取证'
                },
                {
                    key: '最新摇号',
                    name: '最新摇号'
                },
                {
                    key: '在售',
                    name: '在售楼盘'
                }
            ],
            items: [],
            loading: true,
            no_more: false
        }
    },
    methods: {
        changeTab (val) {
            this.selected_tab = val
            this.page = 1
            this.items = []
            this.getList({
                fix_tab: true
            })
        },
        async getList (opt = { fix_tab: false }) {
            this.loading = true
            const { items } = await Service.getBuildings({
                page: this.page,
                per: 10,
                status: BUILDING_STATUS[this.selected_tab]
            })
            if (this.page === 1) {
                this.items = items
            } else {
                this.items.push(...items)
            }
            this.loading = false
            this.no_more = items.length < 10
            if (this.page === 1 && opt.fix_tab) {
                this.$nextTick(() => {
                    const bottom_list = document.getElementById('bottom_list')
                    const { offsetTop, scrollTop } = bottom_list
                    const building_scroll_top = offsetTop + scrollTop
                    window.scrollTo(0, building_scroll_top)
                })
            }
        }
    }
}